import React from 'react'
import PropTypes from 'prop-types'
import { EXERCISE_TYPE_MESSAGE } from '@gymaholic/packages'
import PageSubTitle from 'components/Page/Page.SubTitle'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import ExerciseChip from 'pages/Exercise/components/Chip'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  exerciseType: {
    id: 'Exercise.exerciseType',
    defaultMessage: 'Exercise type'
  }
})

export function ExerciseType ({
  type
}) {
  const intl = useIntl()

  return (
    <View mt={2}>
      <PageSubTitle style={{ marginBottom: 0 }}>
        {formatMessageIntlUtil(intl, messages.exerciseType)}
      </PageSubTitle>
      <View
        row
        mt='10px'
        mb
      >
        <ExerciseChip
          text={formatMessageIntlUtil(intl, EXERCISE_TYPE_MESSAGE[type])}
        />
      </View>
    </View>
  )
}

ExerciseType.propTypes = {
  type: PropTypes.string.isRequired
}
